import { motion } from "framer-motion";
import { Clock, MessageCircle, Sparkles } from 'lucide-react';
import imgBroadwayBingoBallEstLogo2 from "../assets/images/estSmall.png"
import React from 'react';

export default function HoursSection() {
  return (
    <section className="relative bg-gradient-to-br from-[#de0016] via-[#c40014] to-[#de0016] text-white py-20 overflow-hidden">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,_white_1px,_transparent_1px)] bg-[size:40px_40px] animate-pulse" />
      </div>

      {/* Floating shapes */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-white/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 max-w-6xl mx-auto">
          {/* Hours Card */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white/10 backdrop-blur-md rounded-3xl p-8 lg:p-10 border border-white/20 shadow-2xl hover:shadow-3xl transition-all hover:bg-white/15"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-white/20 rounded-2xl">
                <Clock className="w-8 h-8" />
              </div>
              <h2 className="font-['Josefin_Sans'] font-bold text-4xl lg:text-5xl text-white">
                Hours
              </h2>
            </div>
            
            <div className="font-['Josefin_Sans'] space-y-6 text-xl lg:text-3xl">
              <div className="space-y-3">
                <p className="text-white/90">Wednesday-Monday</p>
                <div className="ml-6 space-y-2 text-lg lg:text-xl">
                  <div className="flex items-center gap-2">
                    <Sparkles className="w-5 h-5 text-yellow-300" />
                    <span>Doors Open: <span className="">4:00 PM</span></span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Sparkles className="w-5 h-5 text-yellow-300" />
                    <span>Play Starts: <span className="">6:00 PM</span></span>
                  </div>
                </div>
              </div>
              <div className="pt-4 border-t border-white/20">
                <p className="text-white/90">Closed on Tuesdays</p>
              </div>
            </div>
          </motion.div>

          {/* Texting Club Card */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white/10 backdrop-blur-md rounded-3xl p-8 lg:p-10 border border-white/20 shadow-2xl hover:shadow-3xl transition-all hover:bg-white/15 flex flex-col justify-center"
          >
            <div className="text-center space-y-6">
              <div className="flex justify-center">
                <div className="p-4 bg-white/20 rounded-full">
                  <MessageCircle className="w-10 h-10" />
                </div>
              </div>
              
              <p className="font-['Josefin_Sans'] text-lg lg:text-xl text-white/90 max-w-md mx-auto leading-relaxed">
                For information on daily gameplay and prizes, sign up for our texting club:
              </p>
              
              <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/30">
                <a href="https://optin.mobiniti.com/broadwaybingo" className="font-['Josefin_Sans'] text-3xl lg:text-3xl font-bold mb-2 text-yellow-300">
                  Opt In Here!
                </a>
                <motion.p 
                  className="font-['Josefin_Sans'] text-3xl lg:text-4xl font-bold"
                  whileHover={{ scale: 1.05 }}
                >
                  
                  
                </motion.p>
                <a style={{fontSize: '10px',}} href="/terms" target="_blank">
                        Terms and Conditions
                    </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Est Logo */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex justify-center mt-16"
        >
          <motion.div
            whileHover={{ rotate: 360, scale: 1.1 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-white/20 rounded-full blur-xl" />
            <img 
              alt="Broadway Bingo Est. 1994 by PJ" 
              className="relative w-36 h-36 lg:w-[195px] lg:h-[195px] drop-shadow-2xl"
              src={imgBroadwayBingoBallEstLogo2} 
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
